var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.421,
    height: 50.182,
    viewBox: "0 0 89.421 50.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M39.2,0V35.166L22.342,5.97,17.574,8.723,35.151,39.169,5.985,22.33,3.232,27.1,33.678,44.677H0v5.506H44.711V44.677H44.7v-.011l.006,0v.024H89.421V39.9H53.014L83.464,22.317l-2.4-4.152L49.488,36.4,67.067,5.949l-4.153-2.4L44.7,35.093V0Z",
    transform: "translate(0 0)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.0ade070f02a5152b4c157bf3b55d50dd.svg";
export { ForwardRef as ReactComponent };